const bookWithMeFaqUrl = 'https://aka.ms/openbookfaq';
export default bookWithMeFaqUrl;
